export const CLIENT_PATHS = {
  ADMIN: '/admin',
  ADMIN_PROFILE: '/admin/profile',

  ADMIN_LOGIN: '/auth/admin/login',
  ADMIN_REGISTER: '/auth/admin/register',
  ADMIN_FORGOT_PASSWORD: '/auth/admin/forgot-password',

  ADMIN_TENANT_CREATE: '/admin/tenant/create',
  ADMIN_TENANT_LIST: '/admin/tenant',
  ADMIN_TENANT_EDIT: '/admin/tenant/:id/edit',

  ADMIN_RESELLER_LIST: '/admin/reseller',
  ADMIN_RESELLER_CREATE: '/admin/reseller/create',
  ADMIN_RESELLER_EDIT: '/admin/reseller/:id/edit',

  RESELLER: '/reseller',

  RESELLER_PROFILE: '/reseller/profile',

  RESELLER_LOGIN: '/auth/reseller/login',

  RESELLER_TENANT_LIST: '/reseller/tenant',
  RESELLER_TENANT_CREATE: '/reseller/tenant/create',
  RESELLER_TENANT_EDIT: '/reseller/tenant/:id/edit',

  CUSTOMER_LOGIN: '/website/:websiteId/auth/customer/login',
  CUSTOMER_FIRST_ACCESS: '/website/:websiteId/auth/customer/first-access',
  CUSTOMER_FORGOT_PASSWORD: '/website/:websiteId/auth/customer/forgot-password',

  CUSTOMER_OPEN_TICKET: '/website/:websiteId/customer/support/open-ticket',

  CUSTOMER_DASHBOARD: '/website/:websiteId/customer/dashboard',
  CUSTOMER_PROFILE: '/website/:websiteId/customer/profile',
  CUSTOMER_INVOICE: '/website/:websiteId/customer/invoice/:invoiceId/:dueDate',
  CUSTOMER_INVOICE_PIX:
    '/website/:websiteId/customer/invoice/:invoiceId/:dueDate/pix',
  CUSTOMER_INVOICE_BOLETO:
    '/website/:websiteId/customer/invoice/:invoiceId/:dueDate/boleto',

  CUSTOMER_INVOICES: '/website/:websiteId/customer/invoice',
  CUSTOMER_NFS: '/website/:websiteId/customer/nf',
  CUSTOMER_HIRED_PACKAGES: '/website/:websiteId/customer/hired-package',
  CUSTOMER_SUPPORTS: '/website/:websiteId/customer/support',
  CUSTOMER_FEEDBACK: '/website/:websiteId/customer/feedback',

  PUBLIC_AREA_LOGIN: '/website/:websiteId/public-area/login',
  PUBLIC_AREA_PANEL: '/website/:websiteId/public-area/panel',
  PUBLIC_AREA_HOME: '/website/:websiteId/public-area/panel/home',
} as const;
